<template>
  <error-page-wrap>
    <error-page-content :error-data="errorData" />
    <footer-component v-if="isFooterShown" />
  </error-page-wrap>
</template>

<script>
import { mapGetters } from 'vuex';

import customStylesHandler from '@/mixins/customStylesHandler';
import styled from 'vue-styled-components';

import FooterComponent from '@/components/Footer/FooterComponent';
import ErrorPageContent from '@/pages/ErrorPage';

const ErrorPageWrap = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
`;

export default {
  created() {
    console.log('Created layout', this.errorData);
  },
  computed: {
    ...mapGetters('UI', ['isFooterShown']),
  },
  components: {
    FooterComponent,
    ErrorPageContent,
    ErrorPageWrap,
  },
  mixins: [customStylesHandler],
  props: {
    errorData: {
      type: [Object, Error],
    },
  },
};
</script>
